import {
  isChartReportType,
  isFinancialStatementReportType,
  isListReportType,
  isPivotReportType,
  usesTabularConfiguration,
  isTileReportType,
} from "../../utilities/reportTypeHelper.ts";
import type { DimensionDescriptor, ReportType } from "../../../../../../api/types/svTypes.ts";
import { ItemDataType } from "../../../../../../api/types/svTypes.ts";

export const filterDimensions = (
  reportType: ReportType | undefined,
  dimensions: DimensionDescriptor[],
  ledger?: string
) => {
  if (!reportType) {
    return dimensions;
  }
  if (isListReportType(reportType)) {
    return ledger ? dimensions.filter((dimension) => dimension.supportedLedgerNames?.includes(ledger)) : dimensions;
  }
  if (usesTabularConfiguration(reportType) || isTileReportType(reportType)) {
    return dimensions;
  }
  if (isPivotReportType(reportType) || isChartReportType(reportType) || isFinancialStatementReportType(reportType)) {
    return dimensions.filter((d) => d.type === ItemDataType.Date || d.type === ItemDataType.General);
  }
  throw new Error(`Unsupported report type: ${reportType}`);
};
